import { render, staticRenderFns } from "./SandboxCatalogPage.vue?vue&type=template&id=6eece570&scoped=true&"
import script from "./SandboxCatalogPage.vue?vue&type=script&lang=ts&"
export * from "./SandboxCatalogPage.vue?vue&type=script&lang=ts&"
import style0 from "./SandboxCatalogPage.vue?vue&type=style&index=0&id=6eece570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eece570",
  null
  
)

export default component.exports